import { Prisma } from "@prisma/client";

export const emailConsentValues =
  Prisma.validator<Prisma.EmailConsentDefaultArgs>()({
    select: {
      id: true,
      email: true,
      hasConsented: true,
      reason: true,
      isFromWebApp: true,
      updatedAt: true,
      organiser: {
        select: {
          admin: {
            select: {
              firstName: true,
              lastName: true,
            },
          },
        },
      },
      structure: {
        select: {
          businessName: true,
          admin: {
            select: {
              firstName: true,
              lastName: true,
            },
          },
        },
      },
      user: {
        select: {
          firstName: true,
          lastName: true,
          isProfessional: true,
        },
      },
    },
  });
export type EmailConsent = Prisma.ConsentGetPayload<typeof emailConsentValues>;
